@let author = data.author;

<section class="centered-with-padding grid grid-cols-1 py-7 desk:grid-cols-[auto_715px] desk:gap-x-4 desk:pb-14">
  <div class="order-1 desk:order-2">
    @if (data.editorial; as editorial) {
      <div class="flex flex-col gap-y-2.5 rounded-2xl bg-gray-light px-6 pb-12 pt-8 desk:px-8 desk:pb-8">
        <span class="text-[20px] font-bold">{{ editorial.title }}</span>
        <div [innerHtml]="editorial.content"></div>
        <div class="flex flex-col">
          <span class="font-bold">{{ author.firstName }} {{ author.lastName }}</span>
          <span>{{ author.position }}</span>
        </div>
      </div>
      <div
        class="mx-5 -mt-8 grid h-[108px] grid-cols-[auto_108px] gap-x-2.5 overflow-hidden rounded-2xl bg-purple pl-5 desk:-mt-16 desk:ml-auto desk:mr-12 desk:w-[308px]">
        <div class="flex flex-col justify-center gap-y-1">
          <span class="font-title-alt text-[20px]">{{ author.firstName }}</span>
          <span class="font-title text-[25px]">{{ author.lastName }}</span>
        </div>
        <div class="relative overflow-hidden rounded-2xl">
          @if (data.bannerImage; as image) {
            <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks" [pregenerationSize]="{ width: 1280 }" />
          }
        </div>
      </div>
    }
  </div>

  <div class="order-2 desk:order-1">
    @if (data.svgStickers; as stickers) {
      @let sticker_1 = stickers[0];
      @let sticker_2 = stickers[1];
      <div class="flex justify-center py-5">
        @if (sticker_1) {
          <app-svg [height]="113" [src]="sticker_1.svg" [width]="95" class="z-10 rotate-[-7deg]" />
        }
        @if (sticker_2) {
          <app-svg [height]="113" [src]="sticker_2.svg" [width]="95" class="-ml-2 mt-1 rotate-3" />
        }
      </div>
    }
  </div>
</section>
